import reduce from './utils/reduce'

const { assign } = Object

const omit = (model, keys) => {
  if (!keys.length || !model.selectors) return model

  const { ...copy } = model.selectors
  const newSelectors = reduce(keys, (props, key) => {
    if (props.hasOwnProperty(key)) delete props[key]
    return props
  }, copy)

  return assign(model, { selectors: newSelectors })
}

export default omit
